import FixedBottomNavigation from '../components/bottomNavigation/bottomNavigation';
import CustomizedAppBar from '../components/appBar/CustomizedAppBar';

const MainLayout = () => {
    return (
        <div className="mainLayout">
            <CustomizedAppBar />
            <FixedBottomNavigation />
        </div>
    );
};

export default MainLayout;
